<aside class="bg-white border-r border-gray-200 flex flex-col transition-all duration-300 h-full"
  [ngClass]="isOpen ? 'w-64' : 'w-18'">

  <div class="h-16 flex items-center justify-between px-4" [ngClass]="{'justify-center': !isOpen}">
    @if(isOpen){
    <div class="flex items-center gap-3 font-semibold text-lg">
      <div class="w-10 h-10 min-w-10">
        <img src="logo.png" alt="" class="w-full h-full object-cover">
      </div>
      <span class="whitespace-nowrap">Indian Railways</span>
    </div>
    } @else {
    <div class="w-10 h-10 min-w-10">
      <img src="logo.png" alt="" class="w-full h-full object-cover">
    </div>
    }
  </div>



  <nav class="flex-1 overflow-y-auto mt-6 px-3">

    @for (group of menuItems; track $index) {

    @if(isOpen){
    @if(group.section.length>0){
    <div class="px-3 mb-3 mt-6 text-xs font-semibold tracking-widest text-gray-400 uppercase">
      {{ group.section }}
    </div>
    }
    }

    @for (item of group.items; track item.route) {

    <a [routerLink]="item.disabled ? null : item.route" [class.bg-brand-500]="isItemActive(item) && !item.disabled"
      [class.text-white]="isItemActive(item) && !item.disabled"
      [class.font-medium]="isItemActive(item) && !item.disabled"
      [class.shadow-sm]="isItemActive(item) && !item.disabled"
      [class.hover:bg-brand-500]="isItemActive(item) && !item.disabled"
      [class.text-gray-700]="!isItemActive(item) || item.disabled"
      [class.hover:bg-gray-100]="!isItemActive(item) && !item.disabled" [class.opacity-40]="item.disabled"
      [class.pointer-events-none]="item.disabled" [pTooltip]="item.label" [tooltipDisabled]="isOpen"
      tooltipPosition="right"
      class="flex items-center min-h-11 gap-3 px-3 py-2.5 mb-2 cursor-pointer !rounded-xl corner-smoothing transition-all duration-200"
      [ngClass]="{
          'justify-center': !isOpen,
          'justify-between': isOpen
        }">

      <div class="flex items-center gap-3 min-w-0">
        <i [class]="item.icon + ' text-xl'"></i>

        @if(isOpen){
        <span class="truncate">
          {{ item.label }}
        </span>
        }
      </div>

      @if(isOpen && item.badge && !item.disabled){
      <span
        class="flex items-center justify-center min-w-7 h-7 px-2 text-xs font-semibold bg-gray-100 text-gray-600 rounded-full">
        {{ item.badge }}
      </span>
      }

    </a>

    }
    }

  </nav>
  @if (bottomMenuItems && bottomMenuItems.length > 0) {
  <div class="p-3 mt-auto">
    @for (item of bottomMenuItems; track $index) {
    <a class="flex items-center gap-3 px-3 py-2.5  mt-3 text-gray-700 hover:bg-gray-100 cursor-pointer corner-smoothing"
      [ngClass]="{'justify-center': !isOpen}">
      <i [class]="item.icon + ' text-2xl'"></i>
      @if(isOpen){
      <span class="font-medium">{{ item.label }}</span>
      }
    </a>
    }
  </div>
  }

  <div class="min-h-11 flex items-center gap-3 p-3 border-t border-gray-200" [ngClass]="{'justify-center': !isOpen}">
    @if(isOpen){
    <span
      class="w-10 h-10 rounded-full bg-gray-700 text-gray-200 ti ti-user-filled flex items-center justify-center text-2xl"></span>
    <div class="flex flex-col flex-1">
      <span class="font-medium text-sm">{{ userFullName() }}</span>
      <span class="text-xs text-gray-500">{{ 'Admin' }}</span>
    </div>
    <p-button text="true" icon="ti ti-logout text-xl" pTooltip="Logout" severity="danger" (click)="onLogout()" />
    } @else {
    <span
      class="w-10 h-10 rounded-full bg-gray-700 text-gray-200 ti ti-user-filled flex items-center justify-center text-2xl"
      [pTooltip]="userFullName() || 'User'" tooltipPosition="right"></span>
    }
  </div>
</aside>